import './HomepageTab.less';

import React, { FC } from 'react';
import clsx from 'clsx';
import { isMobileChannel } from '../../../common/util';
import { SportIconNui } from '../../../icons/SportIconNui';

const HomepageTab: FC<{
    label: string;
    onClick?: () => void;
    active?: boolean;
    otherClass?: boolean;
    sportId?: string;
}> = ({ label, onClick, active, otherClass, sportId, children }) => {
    return (
        <button
            className={clsx(
                'homepage-tab bg-white-box px-15 flex-center fs-16 f-condensed no-wrap',
                active ? 'c-black-100' : 'c-black-50',
                otherClass,
                { 'hover-ng': !isMobileChannel() }
            )}
            onClick={onClick}
        >
            {sportId && (
                <SportIconNui
                    sportId={`${sportId}`}
                    sizeX="20"
                    sizeY="20"
                    className={`flex-shrink-0 fill-${sportId} mr-15`}
                />
            )}
            <span title={label} className={clsx('homepage-tab-label', { 'text-extra-bold': active })}>
                {label}
            </span>
            {children}
        </button>
    );
};

export default HomepageTab;
